/* ── Shared validation utilities for all forms across the site ──
   Import these instead of writing inline validation per component. */

// ── URL Validation ──
// Accepts: https://example.com, http://example.com, example.com, www.example.com
// Rejects: empty strings, single words without dots, obviously invalid formats
export function isValidUrl(input) {
  if (!input || !input.trim()) return false;
  let url = input.trim();
  // Auto-prepend https:// if no protocol
  if (!/^https?:\/\//i.test(url)) url = "https://" + url;
  try {
    const parsed = new URL(url);
    // Must have a dot in the hostname (rejects "localhost" and single words)
    return parsed.hostname.includes(".");
  } catch {
    return false;
  }
}

// Normalizes a URL by prepending https:// if missing
export function normalizeUrl(input) {
  if (!input || !input.trim()) return "";
  let url = input.trim();
  if (!/^https?:\/\//i.test(url)) url = "https://" + url;
  return url;
}

// ── Email Validation ──
// Standard email regex - covers 99% of valid emails
export function isValidEmail(input) {
  if (!input || !input.trim()) return false;
  const email = input.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// ── Required Field ──
export function isNotEmpty(input) {
  return input && input.trim().length > 0;
}

// ── Character Limit Check ──
export function isWithinLimit(input, max) {
  return !input || input.length <= max;
}
